const SDK_WAIT_TIMEOUT_MS = 10000

export class SocialSdkTimeoutError extends Error {
  constructor() {
    super('Social login SDK timed out')
  }
}

export default function waitForSocialSdk(ready: Promise<void>): Promise<void> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => reject(new SocialSdkTimeoutError()), SDK_WAIT_TIMEOUT_MS)
    ready.then(() => {
      window.clearTimeout(timeout)
      resolve()
    }, (error) => {
      window.clearTimeout(timeout)
      reject(error)
    })
  })
}
